export default [
  {
    path: "/cidade/:municipioId/revisoes-tecnicas",
    name: "technical-review-list",
    component: () => import("./components/List.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cidade/:municipioId/revisoes-tecnicas/nova",
    name: "technical-review-create",
    component: () => import("./components/Form.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cidade/:municipioId/revisoes-tecnicas/:revisaoId",
    name: "technical-review-detail",
    component: () => import("./components/Detail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cidade/:municipioId/revisoes-tecnicas/:revisaoId/editar",
    name: "technical-review-edit",
    component: () => import("./components/Form.vue"),
    meta: { requiresAuth: true },
  },
];

